import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { API_URL } from './config';
import Margin from './Margin';
import MarginV2 from './MarginV2';
import './Equity.css';

/* ------------------------------------------------------------------ *
 * Picks the Margin page layout for Equity > Margin. The decision is made
 * server-side (GET /portfolio/margin/layout/, portfolio/margin_v2_views.py):
 *   ?layout=v1 / ?layout=v2   forces that layout (side-by-side testing)
 *   otherwise                 v2 if MARGIN_V2_ENABLED, else v1
 * If the layout endpoint can't be reached, v1 is shown unless v2 was
 * explicitly requested.
 * ------------------------------------------------------------------ */
function MarginSwitch() {
  const [searchParams] = useSearchParams();
  const requested = searchParams.get('layout');
  const [layout, setLayout] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setLayout(null);
    axios
      .get(`${API_URL}/portfolio/margin/layout/`, { params: requested ? { layout: requested } : {} })
      .then((response) => { if (!cancelled) setLayout(response.data.layout); })
      .catch(() => { if (!cancelled) setLayout(requested === 'v2' ? 'v2' : 'v1'); });
    return () => { cancelled = true; };
  }, [requested]);

  if (layout === null) {
    return (
      <div className="equity-container">
        <div className="equity-loading">Loading...</div>
      </div>
    );
  }
  return layout === 'v2' ? <MarginV2 /> : <Margin />;
}

export default MarginSwitch;
